import React from 'react'
import classNames from 'classnames'

const CelebrationBanner = ({
    show = false,
    message = '🎊 Congratulations! Target achieved! 🎊',
    type = 'success',
    className,
}) => {
    if (!show) return null

    const baseClasses = 'mt-3 p-3 rounded-lg border'

    const typeClasses = {
        success: 'bg-green-50 border-green-200 text-green-700',
        info: 'bg-blue-50 border-blue-200 text-blue-700',
        warning: 'bg-yellow-50 border-yellow-200 text-yellow-700',
        celebrate: 'bg-purple-50 border-purple-200 text-purple-700',
    }

    return (
        <div className={classNames(baseClasses, typeClasses[type], className)}>
            <p className="text-sm font-medium text-center">{message}</p>
        </div>
    )
}

export default CelebrationBanner
